<div class="popup">
  <div class="container-detalles panelValetParking">

    <div class="details-flex">
      
      <!-- Header Section -->
      <div class="header_panel">
        
        <div class="header-background">
          <img [src]="'carA.png' | findUrl" class="header-img" />
        </div>

        <div class="row header-text">
          <label class="vin-title-container">
            <div class="btnReturn" (click)="CloseDialog()" matTooltip="Regresar">
              <mat-icon>arrow_back_ios</mat-icon>
            </div>

            <div class="copy-to-clipboard">
              <!-- <mat-icon>toll</mat-icon> -->
               <img [src]="'crear_valet_parking.svg' | findUrl">
            </div>
            <div class="vin-title">
              Crear Valet Parking
            </div>
          </label>
          <label class="vin-title">{{this.identificador}}</label>
          <label class="subtitlePanel">{{this.descripcion}}</label>
        </div>

      </div>

      <div class="valet-content-container">

        <div class="data-section-container">
          <div class="text-header">
            <h3>Arrastre la pantalla para seleccionar un punto</h3>
          </div>
          <div class="button-group">
            <div class="button" mat-button *ngFor="let option of options; let i = index"
                [ngClass]="{'selected': selectedOption === option}"
                (click)="selectOption(option)">
              {{ option }}
            </div>
          </div>
        </div>

        <div class="data-section-container">
          <div class="text-header">
            <h3>Datos de Notificación</h3>
          </div>
          <div class="form-flex">

            <div class="valet-form-button">
              <label>Correo</label>
              <mat-form-field appearance="fill">
                <input matInput [(ngModel)]="mail">
              </mat-form-field>
            </div>

            <!-- <div class="valet-form-button">
              <label>Teléfono</label>
              <mat-form-field appearance="fill">
                <input matInput [(ngModel)]="phone">
              </mat-form-field>
            </div> -->
          </div>
        </div>

        <div class="action-buttons">
          <button mat-raised-button (click)="SendData()">Crear</button>
          <button mat-raised-button (click)="CloseDialog()">Cancelar</button>
        </div>

      </div>
    </div>

  </div>
</div>

